import { render, staticRenderFns } from "./changepass.vue?vue&type=template&id=8b45528e&scoped=true"
import script from "./changepass.vue?vue&type=script&lang=js"
export * from "./changepass.vue?vue&type=script&lang=js"
import style0 from "./changepass.vue?vue&type=style&index=0&id=8b45528e&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./changepass.vue?vue&type=style&index=1&id=8b45528e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b45528e",
  null
  
)

export default component.exports